import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./FaqSection.css";
import { useSelector } from "react-redux";

// SAME FUNCTION (NO CHANGE)
const getPageFaqType = (pathname, menusData) => {
  if (!menusData || menusData.length === 0) {
    return pathname.substring(1).split("/")[0] || "home";
  }

  const flattenMenus = (menus) => {
    let result = [];
    menus.forEach((menu) => {
      result.push(menu);
      if (menu.children && menu.children.length > 0) {
        result = result.concat(flattenMenus(menu.children));
      }
    });
    return result;
  };

  const allMenus = flattenMenus(menusData);
  const matchedMenu = allMenus.find((menu) => menu.url === pathname);

  if (matchedMenu && matchedMenu.slug) {
    return matchedMenu.slug;
  }

  if (pathname.startsWith("/services/")) return "services";
  if (pathname.startsWith("/instant-services-detail/")) return "service-detail";

  return pathname.substring(1).split("/")[0] || "home";
};

const FaqSection = ({
  title = "Frequently Asked Questions",
  subtitle = "Find Answers To Common Questions About Our Services And Processes",
}) => {
  const [faqsError, setFaqsError] = useState("");
  const [openFaqs, setOpenFaqs] = useState({});
  const [visibleCount, setVisibleCount] = useState(6);
  const location = useLocation();

  const isHomePage = location.pathname === "/" || location.pathname === "/home";

  const toggleFaq = (id) => {
    setOpenFaqs((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  // ✅ SAFE SELECTORS (NO CRASH)
  const faqState = useSelector((state) => state.faq);
  const menuState = useSelector((state) => state.menu);

  const faqs = faqState?.faqs || [];
  const loadingFaqs = faqState?.loading || false;

  const menus = menuState?.menus || [];
  const loadingMenus = menuState?.loading || false;

  // SAME FILTER (NO CHANGE)
  const filteredFaqs = faqs.filter((faq) => {
    if (isHomePage) return true;

    if (loadingMenus) return false;

    const mappedType = getPageFaqType(location.pathname, menus);

    return faq.faq_type === mappedType;
  });

  const visibleFaqs = filteredFaqs.slice(0, visibleCount);
  const hasMore = visibleCount < filteredFaqs.length;
  const showingMore = visibleCount > 6;

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 6);
  };

  const handleShowLess = () => {
    setVisibleCount(6);
    document
      .getElementById("faq")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const isLoading = loadingFaqs || (!isHomePage && loadingMenus);

  if (!isLoading && !isHomePage && filteredFaqs.length === 0) {
    return null;
  }

  return (
    <section id="faq" className="section faq-section">
      <div className="faq-background-overlay"></div>
      <div className="section-header">
        <h2>{title}</h2>
        <p>{subtitle}</p>
      </div>

      <div className="faq-container">
        {isLoading ? (
          <div className="faq-loading">
            <div className="loading-spinner"></div>
            <p>Loading FAQs...</p>
          </div>
        ) : faqsError ? (
          <div className="faq-error">
            <p>{faqsError}</p>
          </div>
        ) : visibleFaqs.length > 0 ? (
          <>
            {visibleFaqs.map((faq) => (
              <div className="faq-item" key={faq.id}>
                <div className="faq-question" onClick={() => toggleFaq(faq.id)}>
                  {faq.question}
                  <span>{openFaqs[faq.id] ? "−" : "+"}</span>
                </div>
                {openFaqs[faq.id] && (
                  <div className="faq-answer">{faq.answer}</div>
                )}
              </div>
            ))}

            {(hasMore || showingMore) && (
              <div className="faq-load-more">
                {hasMore && (
                  <button className="load-more-btn" onClick={handleLoadMore}>
                    <i className="fas fa-chevron-down"></i>
                    View More FAQs
                  </button>
                )}

                {showingMore && (
                  <button className="show-less-btn" onClick={handleShowLess}>
                    <i className="fas fa-chevron-up"></i>
                    Show Less
                  </button>
                )}
              </div>
            )}
          </>
        ) : (
          <div className="faq-empty">
            <p>No FAQs available for this section.</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default FaqSection;
